
import { defineComponent } from "vue";

export default defineComponent({
  name: "user-not-found",
});
